import { Paper, Stack, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { OrganizationTreatmentsContent } from 'src/sections/@dashboard/organization/components/OrganizationTreatments/OrganizationTreatmentsContent';

export default function OrganizationTreatmentsPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Zabiegi | Vetsi</title>
      </Helmet>

      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: 1,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <OrganizationTreatmentsContent />
        </Stack>
      </Paper>
    </>
  );
}
